export default __webpack_public_path__ + "assets/images/e2cb15407dcadcf672ff0672981f116f.svg";